import { atom } from 'nanostores'

export type ChinaAndroidTrialEligibility =
  | 'pending'
  | 'available'
  | 'unavailable'

export const $chinaAndroidTrialEligibility =
  atom<ChinaAndroidTrialEligibility>('pending')

export function setChinaAndroidTrialState(state: ChinaAndroidTrialEligibility) {
  $chinaAndroidTrialEligibility.set(state)
}
